import { useEffect, useState } from 'react';
import { SearchType } from './useSearch';

const useTabs = (): [SearchType, (t: SearchType) => void] => {
  const [tab, setTab] = useState<SearchType>(
    window.location.hash === '#innehall' ? 'retailers_cms' : 'cars'
  );

  useEffect(() => {
    window.addEventListener(
      'hashchange',
      () => {
        if (window.location.hash !== tab) {
          setTab(window.location.hash === '#innehall' ? 'retailers_cms' : 'cars');
        }
      },
      false
    );
    window.addEventListener(
      'popstate',
      () => {
        if (window.location.hash !== tab) {
          setTab(window.location.hash === '#innehall' ? 'retailers_cms' : 'cars');
        }
      },
      false
    );
  }, []);

  return [tab, setTab];
};

export default useTabs;
